import React from "react"
import { Typography } from "antd"
import { useOutletContext } from "react-router-dom"

import Identity from "@components/Identity"
import FormattedValue from "@components/FormattedValue"
import OrganizationDomain from "@modules/console/organizations/OrganizationsTable/OrganizationDomain"
import OrganizationEmail from "@modules/console/organizations/OrganizationsTable/OrganizationEmail"

import TableRowActions from "../TableRowActions"
import OrganizationStatusTag from "../OrganizationStatusTag"


const { Text } = Typography


const useTableColumns = (table) => {
  const { users, computeUserFullname } = useOutletContext()

  const getUserId = userCorrelationId => {
    const user = users
      .find(({ correlationId }) => correlationId === userCorrelationId)

    if (!user) {
      return null
    }

    return user.id
  }

  const computeFullname = userCorrelationId => {
    const userId = getUserId(userCorrelationId)

    return computeUserFullname(userId)
  }

  const nameColumnProps = {
    key: "name",
    title: "Name",
    render: value => <Text strong>{value}</Text>,
    isSearchable: true
  }

  const domainColumnProps = {
    key: "domain",
    render: (value, organization) => <OrganizationDomain
      organization={organization}
    />,
    isSearchable: true,
  }

  const emailColumnProps = {
    key: "email",
    title: "Email",
    render: (value, organization) => <OrganizationEmail
      organization={organization}
    />,
  }

  const createdByColumnProps = {
    key: "createdBy",
    compute: ({ createdBy }) => computeFullname(createdBy),
    render: (fullname, { createdBy }) => (
      getUserId(createdBy)
        ? <Identity id={getUserId(createdBy)}>{fullname}</Identity>
        : "N/A"
    ),
    isSearchable: true,
  }

  const statusColumnProps = {
    key: "isDisabled",
    title: "Status",
    render: (_, { isDisabled, disableReason }) => <OrganizationStatusTag
      isDisabled={isDisabled}
      disableReason={disableReason}
    />,
  }

  const createdAtColumnProps = {
    key: "createdAt",
    render: value =>
      <FormattedValue value={value} />
  }

  const actionsColumnProps = {
    key: "actions",
    title: false,
    render: (_, organization) =>
      <TableRowActions
        organization={organization}
        table={table}
      />
  }

  return [
    { ...nameColumnProps },
    { ...domainColumnProps },
    { ...emailColumnProps },
    { ...statusColumnProps, width: 110 },
    { ...createdByColumnProps, width: "auto", widthAutoPadding: 40 },
    { ...createdAtColumnProps, width: 170 },
    { ...actionsColumnProps, width: 48 }
  ]
}

export default useTableColumns
